import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 机构分页列表
export function getAgentPager(req, pager) {
  return request({
    url: apiConfig.agentInfo.api.pager.url,
    method: "post",
    data: {
      agentIds: req.agentIds,
      page: pager.page,
      pageSize: pager.pageSize
    }
  });
}
// 子机构分页列表
export function getSubAgentList(req, pager) {
  return request({
    url: apiConfig.agentInfo.api.getSubAgentList.url,
    method: "post",
    data: {
      agentId: req.agentId,
      page: pager.page,
      pageSize: pager.pageSize
    }
  });
}
// 查询机构信息
export function findAgentById(agentId) {
  return request({
    url: apiConfig.agentInfo.api.find.url,
    method: "get",
    params: {
      agentId: agentId
    }
  });
}
// 查询机构项目列表
export function getExamList(req) {
  return request({
    url: apiConfig.agentInfo.api.getExamList.url,
    method: "post",
    data: {
      agentId: req.agentId,
      page: req.page,
      pageSize: req.pageSize
    }
  });
}
// 查询参与项目用户列表
export function getExamUserPager(req) {
  return request({
    url: apiConfig.agentInfo.api.getExamUserPager.url,
    method: "post",
    data: {
      examId: req.examId,
      page: req.page,
      pageSize: req.pageSize
    }
  });
}

// 机构树结构数据
export function getAgentTree(req, pager) {
  return request({
    url: apiConfig.agentInfo.api.agentTree.url,
    method: "post",
    data: {
      agentId: req.agentId,
      agentIds: req.agentIds,
      agentName: req.agentName,
      contactName: req.contactName,
      status: req.status,
      startDate: req.startDate,
      endDate: req.endDate,
      page: pager.page,
      pageSize: pager.pageSize
    }
  });
}

// 机构树结构分页
export function getAgentTreePager(req, pager) {
  return request({
    url: apiConfig.agentInfo.api.agentTreePager.url,
    method: "post",
    data: {
      agentId: req.agentId,
      agentIds: req.agentIds,
      agentName: req.agentName,
      contactName: req.contactName,
      status: req.status,
      startDate: req.startDate,
      endDate: req.endDate,
      page: pager.page,
      pageSize: pager.pageSize
    }
  });
}

// 代理收益排名
export function getAgentRanking(req) {
  return request({
    url: apiConfig.agentInfo.api.getAgentRanking.url,
    method: "post",
    data: {
      startTime: req.startTime,
      endTime: req.endTime
    }
  });
}

// 查询机构是否注册
export function agentRegisterStatus(params) {
  return request({
    url: apiConfig.agentInfo.api.agentRegisterStatus.url,
    method: "get",
    params,
  });
}
// 机构注册
export function agentRegister(params, data) {
  return request({
    url: apiConfig.agentInfo.api.agentRegister.url,
    method: "post",
    params,
    data
  });
}
// 保存社会组织机构调研问卷
export function addShzzQuestionnaire(data) {
  return request({
    url: apiConfig.agentInfo.api.addShzzQuestionnaire.url,
    method: "post",
    data
  });
}
